import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade,Autoplay } from 'swiper';
import img1 from '../../../../../Assets/Images/SectionTwo/console-img-1@3x.png'
import img2 from '../../../../../Assets/Images/SectionTwo/console-img-2@3x.png'
import img3 from '../../../../../Assets/Images/SectionTwo/console-img-3@3x.png'
import img4 from '../../../../../Assets/Images/SectionTwo/console-img-4@3x.png'
import img5 from '../../../../../Assets/Images/SectionTwo/console-img-5@3x.png'
import './SectionTwo.scss';
import 'swiper/scss';
import 'swiper/scss/autoplay';
import 'swiper/scss/effect-fade';




function SectionTwo() {

  const content="Creative, Fun and- Enjoyable work Impressive"
  const products_recommendList= [
    {
        prodcuct_img: img1,
    },
    {
        prodcuct_img: img2,
    },
    {
        prodcuct_img: img3,
    },
    {
        prodcuct_img: img4,
    },
    {
        prodcuct_img: img5,
    },
]
  return (
    <div className="section-two ">
      <div className="section-two-slogan">
            <h3>{content}</h3>
        </div>
        <div className="section-two-swiper">

          <Swiper className='myIndexSwiper'
              modules={[EffectFade,Autoplay]} 
              loop= {true}
              effect="fade"
              spaceBetween={0}
              slidesPerView={1}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              grabCursor={true}
              >
              {          
                  products_recommendList.map((product:any, index:any) => {
                      return (
                          <SwiperSlide key={index}>
                              <img src={product.prodcuct_img}/>
                          </SwiperSlide>
                          
                      )
                  })
              }
          </Swiper>
        </div>
    </div>
  );
}

export default SectionTwo;
